import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

{/* LOGOS EN BLANCO */ }
import LogoMagueySVG from '../../img/logoBlancoSVG2.svg';
import LogoMaguey2SVG from '../../img/comerElegante.png';

import { useDispatch, useSelector } from 'react-redux'
import { obtenerSolicitudesWithStatus, obtenerSolicitudesWithStatusProceso } from '../../redux/SolicitudesDucks'
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import { withRouter } from 'react-router-dom'
import estilos from './MenuHamburguesaInspeccion.module.css'; { {/*Estilos para el componente*/ } }



import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink
} from "react-router-dom";

import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faCheckDouble, faClock, faCalendar,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faPenToSquare, faEdit, faPersonWalking, faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faPenToSquare, faCheckDouble, faClock, faPersonWalking, faRightFromBracket,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faCalendar)


const { useState } = React;



const BotonMenuHamburguesa = (props) => {






    const currentUser = useSelector(store => store.Usuario.data)
    const loginIn = localStorage.getItem('user')
    let idUsuario = 0
    if (currentUser) {
        idUsuario = currentUser.user[0].id
    }

  
    const serviciosConComercamRutasBasic = [
        { text: 'Solicitud de inscripción', ruta: '/fc_01' }
    ]

    const serviciosConComercamRutasPremium = [

        // { text: 'Solicitud de inscripción', ruta: '/fc_01' },
        { text: 'Uso de marca COMERCAM', ruta: '/fc_05' },
        { text: 'Registro de maguey', ruta: '/fc_06' },
        { text: 'Renovación de certificados', ruta: '/fc_08' },
        { text: 'Certificado de exportación', ruta: '/fc_09' },
        { text: 'Traslado de producto', ruta: '/fc_30' },
        { text: 'Solicitud de seguimiento', ruta: '/fc_31' },
        { text: 'Certificado de venta nacional', ruta: '/fc_33' },
        { text: 'Suspensión y reactivación', ruta: '/fc_34' },
        { text: 'Servicios varios', ruta: '/fc_35' },
        { text: 'Solicitud de actualización', ruta: '/fc_36' },
        { text: 'Compra de hologramas', ruta: '/fc_40' },
        { text: 'Solicitud para productos con mezcal', ruta: '/fc_41' }
    ]
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const mapOpciones = props.opciones;
    return (
        <Fragment>
            <div>
                <NavLink exact to={props.ruta} className={`${estilos.nav_link}`} >
                    <FontAwesomeIcon icon={faCalendar} />
                    <Button
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        sx={{ color: 'white' }}
                    >
                        <div className={`${estilos.nav_name} text-wrap`}>{props.titulo}</div>
                    </Button>
                </NavLink>
                

                    {
                    Object.keys(props.objeto).length === 0 ? (

                        <Fragment></Fragment>
                                    
                    ): (
                        <Fragment>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                >
                                 {props.objeto.map(item => 
                                <NavLink key={item.ruta} exact to={item.ruta} >
                                            <MenuItem onClick={handleClose}>{item.text}</MenuItem>
                                </NavLink>
                                 )}
                            </Menu>
                        </Fragment>
                    )
                    }
                   
                    
              
            </div>
        </Fragment>
    );
};
export default withRouter(BotonMenuHamburguesa)
